import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { Reveal, SplitHeading } from "./Reveal";
import { api } from "../lib/api";

export const Reviews = () => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/reviews").then((r) => setItems(Array.isArray(r.data) ? r.data : [])).catch(() => setItems([]));
  }, []);

  return (
    <section id="reviews" className="mx-auto max-w-[1440px] px-5 py-24 md:px-10 md:py-32" data-testid="reviews-section">
      <div className="grid gap-10 md:grid-cols-12">
        <div className="md:col-span-5">
          <SplitHeading eyebrow="04 — Word on the street" lines={["Players", "talk."]} className="text-6xl md:text-8xl" />
        </div>
        <div className="space-y-4 md:col-span-7">
          {items?.length === 0 && (
            <p className="border-l-2 border-[#a259ff] bg-[#0f0f16] p-7 text-slate-300" data-testid="reviews-empty">Reviews from our buyers will show up here soon.</p>
          )}
          {(items ?? []).map((r, i) => (
            <Reveal key={r.id} delay={Math.min(i, 4) * 0.08}>
              <figure className="border-l-2 border-[#ff3dc8] bg-[#0f0f16] p-7 transition-colors duration-500 hover:border-[#a259ff]" data-testid={`review-card-${i}`}>
                <div className="flex gap-1" aria-label={`${r.rating} out of 5 stars`}>
                  {Array.from({ length: 5 }).map((_, k) => (
                    <Star key={k} className={`h-4 w-4 ${k < (r.rating ?? 5) ? "fill-[#e9d5ff] text-[#e9d5ff]" : "text-slate-600"}`} />
                  ))}
                </div>
                <blockquote className="mt-4 text-lg text-slate-200">{r.text}</blockquote>
                <figcaption className="mt-4 font-mono text-xs uppercase tracking-widest text-slate-400">
                  {r.name}{r.detail ? ` · ${r.detail}` : ""}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
